import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Card, Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ProjectDetails from './ProjectDetails';
import EligibleExpenditure from './EligibleExpenditure';
import '../newRow.css';
import ContractResearchSection from '@rd-web-markets/market/dist/technicalProof/creating_application/ContractResearchSection';
import ProjectDocumentationTab from '../project_documentation/ProjectDocumentationTab';
import Employee from './Employee';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import ElsterAssets from './assets/ElsterAssets';
import Shareholders from './shareholders/Shareholders';
import { hideAssetBasedOnDate } from '../../../technicalProof/creating_application/asset_utils/dateIsBeforeTaretDate';
import projectElsterDetailService from '../../../services/elster/project_elster_detail.service';
import projectDetailService from '../../../services/elster/project_detail.service';
const PROJECT_DETAIL_DATA_TABS = ['project_details_listing', 'eligible_expenditure'];
const ProjectDetailTabs = _ref => {
  var _selectedProject$proj, _selectedProject$proj2;
  let {
    setSelectedProject,
    selectedProject,
    setProjectReports,
    projectReports,
    handleToaster,
    elster,
    setElster
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    search
  } = useLocation();
  const history = useHistory();
  const [projectDetailLoading, setProjectDetailLoading] = useState(false);
  const [updateProjectElsterDetail] = projectElsterDetailService.useUpdate(elster.id, selectedProject === null || selectedProject === void 0 || (_selectedProject$proj = selectedProject.project_elster_detail) === null || _selectedProject$proj === void 0 ? void 0 : _selectedProject$proj.id, setSelectedProject);
  const projectElsterDetailId = selectedProject === null || selectedProject === void 0 || (_selectedProject$proj2 = selectedProject.project_elster_detail) === null || _selectedProject$proj2 === void 0 ? void 0 : _selectedProject$proj2.id;
  const subTab1 = new URLSearchParams(search).get('sub_tab1');
  const isProjectDetailDataTabActive = PROJECT_DETAIL_DATA_TABS.includes(subTab1);
  const {
    projectDetails,
    setProjectDetails,
    fetchProjectDetails,
    updateProjectDetails
  } = projectDetailService.useCrud(projectElsterDetailId, setProjectDetailLoading, false);
  useEffect(() => {
    setProjectDetails(null);
  }, [projectElsterDetailId, setProjectDetails]);
  useEffect(() => {
    if (!isProjectDetailDataTabActive) {
      setProjectDetails(null);
    }
  }, [isProjectDetailDataTabActive, setProjectDetails]);
  useEffect(() => {
    if (isProjectDetailDataTabActive && projectElsterDetailId && !projectDetails) {
      fetchProjectDetails();
    }
  }, [isProjectDetailDataTabActive, projectElsterDetailId, projectDetails, fetchProjectDetails]);
  const selectProjectDetails = e => {
    const subTab1Key = new URLSearchParams(search).get('sub_tab1');
    history.push({
      search: "?main_tab=project_details&sub_tab1=".concat(subTab1Key, "&p_id=").concat(e.target.value)
    });
  };
  const goToTab = key => {
    history.push({
      search: "?main_tab=project_details&sub_tab1=".concat(key, "&p_id=").concat(selectedProject.id)
    });
  };
  const isAssetsTabDisabled = selectedProject && hideAssetBasedOnDate(selectedProject.first_fast_check);
  const isVersion8 = (elster === null || elster === void 0 ? void 0 : elster.version_number) === 'version_8';
  if (!projectReports.length) return /*#__PURE__*/React.createElement("div", null, t('there_is_no_project_selected'));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('project')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.project_name), /*#__PURE__*/React.createElement(Col, {
    md: 6
  }), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('select_project')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Form.Control, {
    defaultValue: new URLSearchParams(search).get('p_id'),
    value: selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.id,
    as: "select",
    name: "project_select",
    onChange: selectProjectDetails,
    size: "md"
  }, /*#__PURE__*/React.createElement("option", {
    value: null
  }), projectReports.map((p, i) => {
    return /*#__PURE__*/React.createElement("option", {
      key: p.id,
      value: p.id
    }, p.project_name);
  })))), !selectedProject ? /*#__PURE__*/React.createElement("div", null, t('please_select_a_project')) : /*#__PURE__*/React.createElement(Card, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Tabs, {
    onSelect: goToTab,
    activeKey: new URLSearchParams(search).get('sub_tab1'),
    className: "mb-3 ms-3",
    defaultActiveKey: 'employee'
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "employee",
    title: t('employee')
  }, /*#__PURE__*/React.createElement(Employee, {
    selectedProjectId: selectedProject.id,
    selectedProject: selectedProject,
    elster: elster
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "shareholders",
    title: t('shareholders')
  }, /*#__PURE__*/React.createElement(Shareholders, {
    selectedProject: selectedProject,
    isVersion8: isVersion8
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "contract_research",
    title: t('contract_research')
  }, /*#__PURE__*/React.createElement(ContractResearchSection, {
    report: selectedProject,
    contractType: 'elster',
    projectElsterDetailId: selectedProject.project_elster_detail.id,
    updateProjectElsterDetail: updateProjectElsterDetail,
    isVersion8: isVersion8
  })), isVersion8 && /*#__PURE__*/React.createElement(Tab, {
    eventKey: "assets",
    title: t('assets'),
    disabled: isAssetsTabDisabled
  }, !isAssetsTabDisabled && /*#__PURE__*/React.createElement(ElsterAssets, {
    selectedProject: selectedProject
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "project_details_listing",
    title: t('project_details_listing')
  }, /*#__PURE__*/React.createElement(ProjectDetails, {
    projectDetails: projectDetails,
    setProjectDetails: setProjectDetails,
    updateProjectDetails: updateProjectDetails,
    elster: elster
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "eligible_expenditure",
    title: t('eligible_expenditure')
  }, /*#__PURE__*/React.createElement(EligibleExpenditure, {
    projectDetails: projectDetails,
    setProjectDetails: setProjectDetails,
    updateProjectDetails: updateProjectDetails,
    elster: elster
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "project_documentation",
    title: t('project_documentation')
  }, /*#__PURE__*/React.createElement(ProjectDocumentationTab, {
    claimProjectReport: selectedProject,
    handleToaster: handleToaster,
    setProjectReports: setProjectReports,
    projectReports: projectReports
  }))))));
};
export default ProjectDetailTabs;